import React from 'react';
import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/core/styles";
import AppColor from "../../../../utilities/AppColor";
import {Box} from "@material-ui/core";
import {Field} from "formik";
import AppCheckbox from "../../../../components/Input/AppCheckbox";
import PropTypes from "prop-types";
import { ADMIN_PERMISSIONS, SYSTEM_ROLE } from 'config/AppConfig';

const useStyles = makeStyles(() => ({
    title: {
        fontSize: '25px',
        color: AppColor.mainColor,
        fontWeight: '600'
    }
}))

const companyPermissionFields = [
    {name: 'dashboard', label: 'label.dashboard'},
    {name: 'users', label: 'label.team'},
    {name: 'jobs', label: 'label.jobs'},
    {name: 'workers', label: 'label.workers'},
    {name: 'clients', label: 'label.participants'},
    {name: 'rates', label: 'label.rates'},
    {name: 'booking', label: 'title.shifts'},
    {name: 'billing', label: 'label.billings'},
    {name: 'payroll', label: 'label.payroll'},
    {name: 'options', label: 'label.options'}
];

const adminPermissionFields = [
    {name: 'dashboard', label: 'label.dashboard'},
    {name: 'users', label: 'label.team'},
    {name: 'company', label: 'label.companies'},
    {name: 'subscriptionPlan', label: 'label.subscriptionPlan'},
    {name: 'transactions', label: 'label.transactions'},
    {name: 'accountSoftware', label: 'label.accountSoftware'},
    {name: 'paymentGateway', label: 'label.paymentGateway'}
];

const SettingFields = props => {
    const { role, permissions, hiddenPermissionFields } = props;
    const {t} = useTranslation();
    const classes = useStyles();
    const permissionFields = role === SYSTEM_ROLE.COMPANY ? companyPermissionFields : adminPermissionFields;
    const visiblePermissionFields = permissionFields.filter(field => {
        if (hiddenPermissionFields.includes(field.name)) {
            return false;
        }
        if (!Array.isArray(permissions)) {
            return true;
        }
        if (role === SYSTEM_ROLE.COMPANY && field.name === 'users') {
            return false;
        }
        return ADMIN_PERMISSIONS[field.name] && permissions.includes(ADMIN_PERMISSIONS[field.name].id);
    });

    return (
        <>
            {role !== SYSTEM_ROLE.COMPANY  &&
                <h3 className={classes.title}>{t('title.email_notification')}</h3>}
            <Box display="flex" flexDirection="column" my={2}>
                {role !== SYSTEM_ROLE.COMPANY && <Field
                    component={AppCheckbox}
                    name="isEmailOnboard"
                    label={t('text.checkbox_onboard')}
                />}
                {/* {role === SYSTEM_ROLE.COMPANY && !isUpdate && <Field
                    component={AppCheckbox}
                    name="isEmailCreatedParticipant"
                    label={t('text.checkbox_create_participant')}
                />} */}
            </Box>
            <h3 className={classes.title}>{t('title.permissions')}</h3>
            <Box display="flex" flexDirection="column" my={2}>
                {visiblePermissionFields.map(field => (
                    <Field
                        key={field.name}
                        component={AppCheckbox}
                        name={field.name}
                        label={t(field.label)}
                    />
                ))}
            </Box>
        </>
    )
}
SettingFields.propTypes  = {
    role: PropTypes.string,
    permissions: PropTypes.arrayOf(PropTypes.string),
    hiddenPermissionFields: PropTypes.arrayOf(PropTypes.string),
}

SettingFields.defaultProps = {
    hiddenPermissionFields: []
}
export default SettingFields;
